const PromoLimitPeriod = Object.freeze({
  Sunday: 1,
  Monday: 2,
  Tuesday: 4,
  Wednesday: 8,
  Thursday: 16,
  Friday: 32,
  Saturday: 64
})

const PromoType = Object.freeze({
  FunCoin: 1,
  GreaterYGiveX: 2,
  XOffLimitYThresholdZ: 3,
  Elite: 8,
  Onsite: 9
})

const PromoTimeType = Object.freeze({
  Range: 0,
  Day: 1,
  Month: 2
})

const PromoApplicablePlatformType = Object.freeze({
  FunNow: 0,
  FunNowBooking: 1
})

const PromoCostAllocationType = Object.freeze({
  FunNow: 0,
  Merchant: 1
})

const PromoCardFunding = Object.freeze({
  Credit: 'Credit Card',
  Debit: 'Debit Card'
})

export {
  PromoLimitPeriod,
  PromoType,
  PromoTimeType,
  PromoApplicablePlatformType,
  PromoCostAllocationType,
  PromoCardFunding
}
